module.exports = __webpack_public_path__ + "img/05.4e71a6d4.png";